import angular from "angular";
import { vsName as conversionModalComponentOptionsName } from "./names";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../records/views/recordGridView";

export interface ConversionModalOptions {
  gridConfiguration: GridConfiguration;
}

export class ConversionModalService {
  static $inject = ["$uibModal", RecordGridViewServiceName];
  constructor(
    private readonly $uibModal: angular.ui.bootstrap.IModalService,
    private readonly recordGridViewService: RecordGridViewService
  ) {}

  openModal(config?: ConversionModalOptions) {
    if (!config) {
      config = {
        gridConfiguration: this.recordGridViewService.getGridConfiguration(
          "machineConfiguration"
        )!,
      };
    }
    return this.$uibModal.open({
      component: conversionModalComponentOptionsName,
      resolve: {
        config: () => config,
      },
    });
  }
}
